import { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

// Reusable heart toggle. Optimistic update with rollback on error.
export default function FavoriteButton({
  profileId,
  initial = false,
  onToggle,
  size = 16,
  className = "",
  showLabel = false,
}) {
  const [fav, setFav] = useState(!!initial);
  const [busy, setBusy] = useState(false);

  useEffect(() => { setFav(!!initial); }, [initial]);

  const toggle = async (e) => {
    if (e) e.stopPropagation();
    if (busy || !profileId) return;
    const next = !fav;
    setBusy(true);
    setFav(next);
    try {
      if (next) await api.post(`/favorites/${profileId}`);
      else await api.delete(`/favorites/${profileId}`);
      if (onToggle) onToggle(next);
    } catch (err) {
      setFav(!next);
      toast.error(err.response?.data?.detail || "Não foi possível atualizar favoritos");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid="favorite-btn"
      onClick={toggle}
      disabled={busy}
      title={fav ? "Remover dos favoritos" : "Guardar nos favoritos"}
      className={`inline-flex items-center gap-1.5 transition-colors ${fav ? "text-[#c8aa6e]" : "text-[#71717a] hover:text-[#c8aa6e]"} ${className}`}
    >
      <Heart style={{ width: size, height: size }} className={fav ? "fill-[#c8aa6e]" : ""} strokeWidth={1.6} />
      {showLabel && <span className="text-xs">{fav ? "Guardado" : "Guardar"}</span>}
    </button>
  );
}
